import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/** Statuses where `date_first_ship` is a delivery; before Delivered it holds the planned ship date (N31). */
export const DELIVERED_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
]);
//# sourceMappingURL=delivered-sales-order-status-ids.js.map